import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { ProductDetailsComponent } from './products/product-details/product-details.component';
import { ProductLeftSidebarComponent } from './products/product-left-sidebar/product-left-sidebar.component';
import { MyAccountComponent } from '../pages/my-account/my-account.component';
import { ProductComponent } from './products/product/product.component';



// Routes
const routes: Routes = [
  {path:'',redirectTo:'home',pathMatch:'full'},
  { path: '', component: HomeComponent },

  { path: 'home', component: HomeComponent },

  {path :'one', component:HomeComponent},
  { path: 'products/:category', component: ProductLeftSidebarComponent },
  { path: 'product/:id', component: ProductDetailsComponent },
  {path:'productt',component:ProductComponent},
  


];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ShopRoutingModule { }
